import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sun, Home, Package, BookOpen, CreditCard, Mail, Menu, X } from 'lucide-react';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/get-started' && location.pathname === '/packages') return true;
    return location.pathname === path;
  };

  const handleNavClick = () => {
    setIsOpen(false);
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  const navItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/get-started', label: 'Get Started', icon: Package },
    { path: '/resources', label: 'Resources', icon: BookOpen },
    { path: '/payment', label: 'Make a Payment', icon: CreditCard },
    { path: '/contact', label: 'Contact', icon: Mail },
  ];

  return (
    <>
      {/* Mobile Menu Toggle */}
      <button 
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
        data-testid="sidebar-toggle"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Overlay for mobile */}
      {isOpen && (
        <div 
          className="sidebar-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`} data-testid="sidebar">
        <div className="sidebar-header">
          <Link to="/" className="sidebar-logo" onClick={handleNavClick}>
            <div className="logo-icon">
              <Sun size={20} />
            </div>
            <div className="logo-text">
              <div className="logo-title">Dr. <span>Drea</span></div>
              <div className="logo-subtitle">Sober Coaching</div>
            </div>
          </Link>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-link ${isActive(item.path) ? 'active' : ''}`}
                onClick={handleNavClick}
                data-testid={`sidebar-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-cta">
            <p>Ready to start your journey?</p>
            <a 
              href="https://calendar.app.google/t7s7ZTE6bSyZNW9Z8"
              target="_blank"
              rel="noopener noreferrer"
              className="sidebar-cta-btn"
              onClick={() => setIsOpen(false)}
            >
              Book Consultation
            </a>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
